// src/components/RegistrationPage.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import RegistrationFlow from './RegistrationFlow';

// This wrapper component conforms to your existing pattern
// It receives templateId from URL params if available
function RegistrationPage() {
  const { templateId } = useParams();
  
  return (
    <div className="registration-page">
      <RegistrationFlow templateId={templateId} />
    </div>
  );
}

export default RegistrationPage;